// extracted by mini-css-extract-plugin
export default {"wrapperSpace":"WrapperSpace_wrapperSpace__h4LwI"};